import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Controllers } from '@shared/core/controllers';
import * as Services from '@shared/core/services';
import * as Utils from '@shared/core/utils';
import * as Models from '@shared/core/models';

import { ModalViewComponent } from '../modal-view.shared.component';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { IModal } from '@shared/state';

@Component({
    selector: 'shared-modal-for-schedule',
    templateUrl: './modal-for-schedule.shared.component.html',
    styleUrls: ['./modal-for-schedule.shared.component.scss']
})
export class ModalForScheduleComponent extends ModalViewComponent implements OnInit {
    private _form!: FormGroup;
    private _pickupTime!: OLO.Ordering.IPickupTime;
    private _dineIn: boolean = false;
    private _collectionTypeSelected: Models.CollectionTypeItem;
    private _submitForm!: (modalId?: number) => any;
    public collectionTypesLinks$: Observable<Models.CollectionTypeItem[]>;
    public selectedCollectionType$: Observable<Models.CollectionTypeItem>;

    constructor(
        public modalsService: Services.ModalsService,
        public heightAdjustService: Services.HeightAdjustService,
        public controllers: Controllers,
    ) {
        super(modalsService, heightAdjustService, null);
    }

    ngOnInit(): void {
        this.size = 'xsm';
        this.collectionTypesLinks$ = this.controllers.collectionType.collectionTypesLinksForLocation$(this.modalData.locationNo);
        this.selectedCollectionType$ = this.controllers.collectionType.collectionTypesLinksSelectedForLocation$(this.modalData.locationNo)
            .pipe(
                tap(collectionType => {
                    this._dineIn = collectionType?.GroupType === OLO.Enums.COLLECTION_TYPE.DINE_IN;
                })
            );
    }

    public handlePickupSelected($event: OLO.Ordering.IPickupTime): void {
        this._pickupTime = $event || null;
    }

    public handleFormInit($event: {
        form: FormGroup;
        context: OLO.Common.IFormContext<any>;
    }): void {
        this._form = $event.form;
        this._submitForm = $event.context.formSubmit.bind($event.context);
    }

    public handleAccept($event: Event): void {
        if (this._dineIn && this._collectionTypeSelected) {
            this.close();
            this.controllers.collectionType.setCollectionType(this._collectionTypeSelected.OrderTypeId);
        } else {
            if (!this._form) return;
            this._submitForm(this.modalData.id);

            if (!this.modalData.params?.update) {
                this.close();
            }
        }
    }

    public handleCollectionTypeChange($event: Models.CollectionTypeItem): void {
        this._collectionTypeSelected = $event;
        this._dineIn = $event.GroupType === OLO.Enums.COLLECTION_TYPE.DINE_IN;
    }

    public get isDineInSelected(): boolean {
        return this._dineIn;
    }

    public get isFormValid(): boolean {
        return this._form && this._form.valid || false;
    }

    public get buttonDynamicLabel(): string {
        if (this._dineIn) return 'Order';

        return this._pickupTime && `Order for ${Utils.Pickups.createPickupLabelName(true, 'common',
            this._pickupTime?.Date || new Date(), this._pickupTime ? this._pickupTime.IsAsap : true)}` || 'Order';
    }
}
